import { cn } from '@klareospace/pharos-lib-web-utils';
import * as React from 'react';

// ─── Types ────────────────────────────────────────────────────────────────────

interface CarrierAvatarProps {
  name: string;
  className?: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function CarrierAvatar({ name, className }: CarrierAvatarProps): React.JSX.Element {
  const initial = name.charAt(0).toUpperCase();
  return (
    <div
      className={cn(
        'flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-muted text-xs font-medium text-muted-foreground',
        className,
      )}
    >
      {initial}
    </div>
  );
}
